import config from "../../../config/config";
import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";

const MOVEMENT_PURPOSES_BASE = `${config.BASE_URL}/to-and-fro-register/purposes`;

async function parseJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { message: text || "Invalid response" };
  }
}

export const getMovementPurposes = async (filters = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.set(key, String(value));
    }
  });
  const res = await authFetch(`${MOVEMENT_PURPOSES_BASE}?${searchParams.toString()}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    const msg =
      (typeof data.details === "string" && data.details.trim()) ||
      data.message ||
      "Failed to load movement purposes";
    throw new Error(msg);
  }
  return data.data;
};

export const getMovementPurpose = async (id) => {
  const res = await authFetch(`${MOVEMENT_PURPOSES_BASE}/${id}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data.message || "Failed to load movement purpose");
  }
  return data.data;
};

export const createMovementPurpose = async (body) => {
  const res = await authFetch(MOVEMENT_PURPOSES_BASE, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data.message || "Failed to create movement purpose");
  }
  return data.data;
};

export const updateMovementPurpose = async (id, body) => {
  const res = await authFetch(`${MOVEMENT_PURPOSES_BASE}/${id}`, {
    method: "PUT",
    credentials: "include",
    headers: buildAuthHeaders(),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data.message || "Failed to update movement purpose");
  }
  return data.data;
};

export const deleteMovementPurpose = async (id) => {
  const res = await authFetch(`${MOVEMENT_PURPOSES_BASE}/${id}`, {
    method: "DELETE",
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data.message || "Failed to delete movement purpose");
  }
  return data.data;
};

export const toggleMovementPurposeStatus = async (id) => {
  const res = await authFetch(`${MOVEMENT_PURPOSES_BASE}/${id}/toggle-status`, {
    method: "PATCH",
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data.message || "Failed to toggle movement purpose status");
  }
  return data.data;
};
